import { render, staticRenderFns } from "./ChangeMyInfo.vue?vue&type=template&id=70f47a55&scoped=true"
import script from "./ChangeMyInfo.vue?vue&type=script&lang=js"
export * from "./ChangeMyInfo.vue?vue&type=script&lang=js"
import style1 from "./ChangeMyInfo.vue?vue&type=style&index=1&id=70f47a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f47a55",
  null
  
)

export default component.exports